import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectCurrentThread, setExternalActionsErrors } from './threadsUiSlice';
import { toastError } from 'src/actions/toast';
import { checkForDeletedBTRResources } from './btResourcesHelper';

export const checkIfBtResourcesDeleted = createAsyncThunk(
  'threadUi/checkIfBtResourcesDeleted',
  async (_, { dispatch, getState }: any) => {
    const currentThread = selectCurrentThread(getState());
    const { values: btResources } = getState().sidekickBTreeResources;

    try {
      const errors = await checkForDeletedBTRResources(currentThread, btResources);
      dispatch(setExternalActionsErrors(errors));
    } catch (e) {
      dispatch(toastError('There was an error while validating bt resource.'));
      return;
    }
  }
);
